import React from "react";
import { getAppointmentPhase } from "shared/utils/enumutils";

interface Props {
  value: server.dto.AppointmentPhases
  displayLabel: boolean
}

const AppointmentPhase = (props: Props) => {
  const phase = getAppointmentPhase(props.value, serverReference);

  return <div className="flex gap">
    <div>
      <i className={phase.icon} title={phase.text} />
    </div>

    {props.displayLabel && <div>{phase.text}</div>}
  </div>;
};

export default AppointmentPhase;